import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { BASE } from 'design-system/variables/spacing';

const EmptyStateContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${BASE * 20}px ${Spacing[5]};
  background-color: ${({ theme }) => theme.color.background.secondary};
`;

const ImageContainer = styled('div')`
  margin-bottom: ${Spacing[4]};
`;

interface TableNullStateProps {
  hasUsedFilters?: boolean;
  dataTestBlock?: string;
  children?: ReactNode;
  image?: ReactNode;
  imageFilter?: ReactNode;
}

const DEFAULT_MESSAGE = 'No results found.';

const TableNullState = ({
  hasUsedFilters = false,
  dataTestBlock,
  children = DEFAULT_MESSAGE,
  image,
  imageFilter,
}: TableNullStateProps) =>
  hasUsedFilters ? (
    <EmptyStateContainer data-test={`${dataTestBlock}__null-state--with-filters`}>
      {imageFilter != null && <ImageContainer>{imageFilter}</ImageContainer>}
      No matched results. Try changing your filters.
    </EmptyStateContainer>
  ) : (
    <EmptyStateContainer data-test={`${dataTestBlock}__null-state--no-filters`}>
      {image != null && <ImageContainer>{image}</ImageContainer>}
      {children}
    </EmptyStateContainer>
  );

export default TableNullState;
